import { render, staticRenderFns } from "./baseDialog.vue?vue&type=template&id=56a7de22&scoped=true"
import script from "./baseDialog.vue?vue&type=script&lang=js"
export * from "./baseDialog.vue?vue&type=script&lang=js"
import style0 from "./baseDialog.vue?vue&type=style&index=0&id=56a7de22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7de22",
  null
  
)

export default component.exports